import Axios from "axios";

export const getUserIP = async () => {
  const res = await Axios.get("https://api64.ipify.org/?format=json");
  return res.data.ip;
};
